import { AffiliationPartner, AffiliationPartnerData, AffiliationPartnerProgram } from './affiliation-partner.model';
import { Itinerary, TransportationReservation } from './itineray.model';
import { Injectable } from '@angular/core';
import { URL, URLSearchParams } from "universal-url";

@Injectable({
  providedIn: 'root'
})
export class AffiliationLinkGeneratorService {

  constructor() { }

  private getAffiliationLink(itineraryId: string, longUrl: string, partner: AffiliationPartner) {

    if (partner) {
      try {
        const partnerData = AffiliationPartnerData.get(partner);
        if (partnerData) {
          switch (partnerData.partnerProgram) {
            // case AffiliationPartnerProgram.AWIN:
            //   return "https://www.awin1.com/cread.php?awinmid=" + partnerData.partnerId + "&awinaffid=501413&clickref=" + itineraryId + "&p=" + longUrl;
            // case AffiliationPartnerProgram.BOOKING:
            //   const aid = "1505452";
            //   const url = new URL(longUrl);

            //   const paramsDefinedValues = [];
            //   url.searchParams.forEach((value, key) => {
            //     if (value) { paramsDefinedValues.push(value); }
            //   });

            //   const paramsMatrixUsed = paramsDefinedValues.length >= 1 && paramsDefinedValues[0].indexOf(";") >= 0;
            //   if (paramsMatrixUsed) {
            //     const matrixParamsInput = longUrl.substring(longUrl.indexOf("?") + 1).split(";");
            //     const matrixParamsOutput = ["aid=" + aid];
            //     for (const matrixParamInput of matrixParamsInput) {
            //       const matrixParamPieces = matrixParamInput.split("=");
            //       if (matrixParamPieces[0] !== "aid") {
            //         matrixParamsOutput.push(matrixParamPieces[0] + "=" + (matrixParamPieces[1] || ""));
            //       }
            //     }
            //     return longUrl.substring(0, longUrl.indexOf("?") + 1) + matrixParamsOutput.join(";");
            //   } else {
            //     if (url.searchParams.has("aid")) {
            //       url.searchParams.delete("aid");
            //     }
            //     url.searchParams.append("aid", aid);
            //     return url.toString();
            //   }
            // case AffiliationPartnerProgram.CJ:
            //   return "http://www.anrdoezrs.net/click-" + partnerData.partnerId + "?sid=" + itineraryId + "&url=" + longUrl;
            default:
              console.warn("Affiliation link generation for partner " + partner + " with program " + partnerData.partnerProgram + " not implemented.");
              return null;
          }
        } else {
          return null;
        }
      } catch (error) {
        console.error("An error has occurred during link with affiliation generation for url " + longUrl, error);
        return null;
      }
    } else {
      return null;
    }
  }

  generate(itinerary: Itinerary) {

    ["flights", "buses", "cars", "ferries", "trains"].forEach((key: string) => {
      const reservations: TransportationReservation[] = itinerary.reservations[key];
      if (reservations && reservations.length > 0) {
        reservations.forEach((reservation: TransportationReservation) => {
          if (reservation.link) {
            reservation.link.longUrlWithAffiliation = this.getAffiliationLink(itinerary.id, reservation.link.longUrl, reservation.partner);
          }
        });
      }
    });
    itinerary.reservations.accomodations.forEach((accomodation) => accomodation.proposals.forEach((proposal) => {
      if (proposal.link) {
        proposal.link.longUrlWithAffiliation = this.getAffiliationLink(itinerary.id, proposal.link.longUrl, proposal.partner);
      }
    }));

  }
}
